import {Injectable, Injector} from '@angular/core';
import {BaseService} from '@twpub/core/services/base.service';
import {Observable} from 'rxjs';
import {ImageFile} from '@twpub/core/models/image-file';
import {HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ImageFileService extends BaseService {
  constructor(injector: Injector) {
    super(injector);
  }

  public getImageFile(id: number): Observable<ImageFile> {
    return this.http.get<ImageFile>(this.url(`/images/${id}`));
  }

  public getContentUrl(fileId: number) {
    return this.url(`/images/${fileId}/content`);
  }

  /**
   * Get logo image file metadata (uses public endpoint, no auth required).
   */
  public getLogoImageFile(id: number): Observable<ImageFile> {
    return this.http.get<ImageFile>(this.url(`/images/logo/${id}`));
  }

  /**
   * Get logo image content URL (uses public endpoint, no auth required).
   */
  public getLogoContentUrl(fileId: number) {
    return this.url(`/images/logo/${fileId}/content`);
  }

  public saveFile(file: File): Observable<ImageFile> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<ImageFile>(this.url('/images'), formData);
  }

  /**
   * Upload logo image from base64 content (used during config import).
   */
  public saveLogoFromBase64(base64Content: string, mimeType: string, name: string, width: number, height: number): Observable<ImageFile> {
    const byteCharacters = atob(base64Content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: mimeType});
    const file = new File([blob], name, {type: mimeType});

    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<ImageFile>(this.url('/images'), formData);
  }

  public updateDimensions(fileId: number, width: number, height: number): Observable<ImageFile> {
    const params = new HttpParams().set('width', width.toString()).set('height', height.toString());
    return this.http.patch<ImageFile>(this.url(`/images/${fileId}`), null, { params });
  }
}
